export default __webpack_public_path__ + "static/media/candleBikram.e1d6a2ec.jpg";